/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Partner_Invite_EnrollingInputs */



/**
* | output |
* | --- |
* | "Setting up your account…" |
*
* @param {Partner_Invite_EnrollingInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const partner_invite_enrolling = /** @type {((inputs?: Partner_Invite_EnrollingInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Partner_Invite_EnrollingInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ ("Konto wird eingerichtet…")
	return /** @type {LocalizedString} */ ("Setting up your account…")
});